import React from "react";
// import PropTypes from 'prop-types';
import Layout from "../../components/Layout";
import EfpaLink from "../../components/EfpaLink";

const TestHome = (props) => {
  return (
    <Layout>
      <div className="Home">
        <h2 className="efpa-h2 efpa-text toUppercase">
          Exámenes efpa - inicio
        </h2>
        <div className="Home-content">
          <span className="efpa-subtitle m-auto">Haga click en una opción</span>
          <div className="Home-options">
            <EfpaLink className="EfpaBtn Home-btn" to="/nueva-inscripcion">
              Inscripción a nuevo examen
            </EfpaLink>
            <span className="efpa-subtitle">Ó</span>
            <EfpaLink className="EfpaBtn Home-btn" to="/mis-examenes">
              Mis exámenes
            </EfpaLink>
          </div>
        </div>
      </div>
    </Layout>
  );
};

TestHome.propTypes = {};

export default TestHome;
